import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiBaseUrl } from "../utils/apiConfig";

const CreateOrganization = () => {
  const [organizationName, setOrganizationName] = useState("");
  const [emails, setEmails] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCreateOrganization = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No token found");
      }

      // Make API call to create organization
      const apiUrl = getApiBaseUrl();
      const response = await axios.post(
        `${apiUrl}/organization`,
        { name: organizationName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const organizationId = response.data.organization._id;

      // Update user data in localStorage
      const userData = JSON.parse(localStorage.getItem("user"));
      userData.organizations.push({ organizationId, role: "admin" });
      userData.onboardingCompleted = true;
      localStorage.setItem("user", JSON.stringify(userData));

      // Make API call to invite members
      if (emails) {
        await axios.post(
          `${apiUrl}/organization/${organizationId}/invite`,
          { emails: emails.split(",").map((email) => email.trim()) },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      // Navigate to the dashboard
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      if (err.response?.data?.message?.includes("already has an organization")) {
        // User already has an organization, redirect to dashboard
        navigate("/dashboard");
      } else {
        setError(err.response?.data?.message || "Error creating organization");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
      <div className="w-full max-w-sm p-6 flex flex-col gap-10">
        <h2 className="text-xl  font-normal text-black-0">
          Create Organization
        </h2>
        <form
          onSubmit={handleCreateOrganization}
          className="flex flex-col gap-7"
        >
          <div className="flex flex-col gap-1">
            <label className="text-grey-60 text-sm  font-medium">
              Organization Name
            </label>
            <input
              className="w-full px-3 py-1 border border-grey-30 rounded-md focus:outline-none"
              type="text"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-grey-60 text-sm  font-medium">
              Invite Members (comma separated emails)
            </label>
            <input
              className="w-full px-3 py-1 border border-grey-30 rounded-md focus:outline-none"
              type="text"
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
            />
          </div>
          <button
            className="w-full py-2 px-4 bg-brand text-white-f text-sm  font-medium tracking-wide rounded-md hover:bg-brand-dark transition"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <div className="inline-block align-middle w-4 h-4 border-2 border-t-2 border-t-white-f border-bg-opacity rounded-full animate-spin"></div>
            ) : (
              "Create Organization"
            )}
          </button>
          {error && (
            <p className="text-red-strong text-sm  font-normal">
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default CreateOrganization;
